import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';
/**
 * 前端：lx
 * 后端：wy
 * 初版时间：2025年11月20日
*/

// 客户引入申请表-分页列表-lx
export const getCustomerIntroductionPage = (data) => {
    return request({
        url: apiCrmHost + '/customer/introduction/page',
        method: 'post',
        data
    });
};

// 客户引入申请表-新增
export const addCustomerIntroduction = (data) => {
    return request({
        url: apiCrmHost + '/customer/introduction/save',
        method: 'post',
        data
    });
};

// 客户引入申请表-删除
export const deleteCustomerIntroduction = (params) => {
    return request({
        url: apiCrmHost + '/customer/introduction/remove',
        method: 'get',
        params
    });
};

// 客户引入申请表-审批
export const queryFlowByIntroduction = (params) => {
    return request({
        url: apiCrmHost + '/customer/introduction/flow/submit',
        method: 'get',
        params
    });
};

// 客户引入申请表-详情
export const getCustomerIntroductionDetail = (params) => {
    return request({
        url: apiCrmHost + '/customer/introduction/detail',
        method: 'get',
        params
    });
};

// 客户引入申请表-附件上传
export const uploadEnclosure = (data) => {
    return request({
        url: apiCrmHost + '/customer/introduction/enclosure/upload',
        method: 'post',
        data
    });
};

// 客户引入申请表-导出
export const exportCustomerIntroduction = (data) => {
    return request({
        url: apiCrmHost + '/customer/introduction/export',
        method: 'post',
        data
    });
};

// 客户引入申请表-附件删除
export const deleteEnclosure = (data) => {
    return request({
        url: apiCrmHost + '/customer/introduction/enclosure/remove',
        method: 'post',
        data
    });
};

// 客户引入申请表-附件分页
export const getEnclosurePage = (data) => {
    return request({
        url: apiCrmHost + '/customer/introduction/enclosure/page',
        method: 'post',
        data
    });
};

export const flowCallbackByMobile = (data) => {
    return request({
        url: apiCrmHost + '/customer/introduction/flow/callback/getMobileForm',
        method: 'post',
        data
    });
};

export const flowCallback = (data) => {
    return request({
        url: apiCrmHost + '/customer/introduction/flow/callback',
        method: 'post',
        data
    });
};
